import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { FormattedDate, FormattedMessage, FormattedNumber, injectIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';
import ActionButton from "../../../common/button/actionbutton.component.jsx";
import ConfirmButton from "../../../common/button/confirmbutton.component.jsx";
import GlobalHelper from "../../../common/GlobalHelper.jsx";
import Icon from "../../../common/icon/icon.component.jsx";
import Integrations from "../../../integration/Integrations.jsx";
import CreditMemoModalLink from '../../../invoice/creditmemomodallink.component';
import CreditMemoTypeIcon from "../../../invoice/creditmemotypeicon.component.jsx";
import EditAndRefundCreditMemoModal from "../../../invoice/editandrefundcreditmemomodal.component.jsx";
import PaymentTypeIcon from "../../../invoice/paymenttypeicon.component.jsx";
import PaymentLink from "../../../payment/components/PaymentLink";
import PaymentExternalDetails from "../../../payment/externaldetails.component.jsx";
import PaymentTypeLabel from "../../../payment/label.component.jsx";
import PaymentSource from "../../../payment/source.component.jsx";
import { Guard, Permissions } from "../../../role/Guard.jsx";
import { PAYMENT_STATUS } from '../../../state/helpers/Payment';
import { INTEGRATION_KEY } from "../../../state/integration/Constants";
import { BILLING_TYPE } from '../../../state/invoice/InvoiceBillingType';
import PaymentTransaction from "../../../state/payment/PaymentTransaction";
import { PAYMENT_TRANSACTION_STATUS_SYNC_REQUESTED } from '../../../state/payment/PaymentTransactionStatus';
import ShopifyExternalCheckoutPaymentAttemptEvent from './shopify-external-checkout-payment-attempt.component';
import EventInfoBlock from "./Utils/EventInfoBlock";
import { DetachPaymentButtonMessage, DetachPaymentModalMessage } from "./Utils/VoidPendingPaymentInfo";

class InvoicePaymentReceivedEvent extends Component {

    constructor(props, context) {
        super(props, context)

        const creditMemo = (this.props.object && this.props.object.attributes.creditMemo) ?
            this.props.object.attributes.creditMemo : null

        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            quote: this.props.quote || null,
            invoice: this.props.invoice || null,
            creditMemo: creditMemo,
            onUpdate: this.props.onUpdate || function () { },
            modal: '',
            isDeleted: this.props.object ? this.props.object.attributes.deleted : false,
            className: this.props.className || '',
            creditMemoFromDeletion: null,
            contactId: this.props.invoice ? this.props.invoice.attributes.contactId : '',
        }
        this.deletePayment = this.deletePayment.bind(this)
        this.exportIntegration = this.exportIntegration.bind(this)
        this.needsManualSync = this.needsManualSync.bind(this)
        this.openCreditMemoEditionModal = this.openCreditMemoEditionModal.bind(this)
    }

    componentDidMount() {

        if (!this.state.creditMemo && this.state.object.attributes.payment.attributes.creditMemoId) {
            AppContext.getApiClient().get('/credit-memos/' + this.state.object.attributes.payment.attributes.creditMemoId).then(res => {
                if (!res.error) {
                    this.setState({
                        creditMemo: res,
                    })
                }
            })
        }

        if (this.state.object.attributes.creditMemoIDFromDeletion) {
            AppContext.getApiClient().get('/credit-memos/' + this.state.object.attributes.creditMemoIDFromDeletion).then(res => {
                if (!res.error) {
                    this.setState({
                        creditMemoFromDeletion: res,
                    })
                }
            })
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            quote: nextProps.quote || null,
            invoice: nextProps.invoice || null,
            proposal: nextProps.proposal || null,
            onUpdate: nextProps.onUpdate || function () { },
            isDeleted: nextProps.object ? nextProps.object.attributes.deleted : false,
        })
    }

    deletePayment(event) {
        event.preventDefault()
        AppContext.getApiClient().delete('/invoices/' + this.state.invoice.id + '/payment-transactions/' + this.state.object.id).then(res => {
            this.state.onUpdate()
        })
    }

    exportIntegration(event) {
        event.preventDefault()
        return AppContext.getApiClient().post('/staff/invoices/payment-transactions/export', {
            invoiceId: this.state.invoice.id,
            paymentTransactionId: this.state.object.id,
        }).then(q => {
            setTimeout(() => {
                this.state.onUpdate()
            }, 4000)
        })
    }

    isReturn() {
        return this.state.invoice && this.state.invoice.attributes.billingType === BILLING_TYPE.RETURN
    }

    getPaymentTypeIcon(payment) {
        payment = payment || this.state.object.attributes.payment
        return payment.attributes.paymentType ?
            payment.attributes.paymentType.attributes.icon : ''
    }

    openCreditMemoEditionModal(event) {
        event.preventDefault()
        this.setState({
            modal: <EditAndRefundCreditMemoModal
                creditMemoId={this.state.creditMemo.id}
                readOnly={true}
                contactId={this.state.contactId}
                onClose={(objectId, objectType) => {
                    if (objectId) {
                        this.setState({
                            modal: <Redirect to={{ pathname: GlobalHelper.getObjectEditPathByObjectType(objectId, objectType) }}>
                            </Redirect>
                        })
                    } else {
                        this.setState({ modal: '' })
                    }
                }}
            />
        })
    }

    renderDeclinedMessage() {
        if (this.state.isDeleted) {
            return [
                <FormattedMessage
                    id="common.analytics.events.payment_detached_or_voided.text"
                    defaultMessage="This {paymentType} of {amount} has been detached or voided."
                    values={{
                        paymentType: <strong><PaymentTypeLabel value={this.state.object.attributes.payment.attributes.type} /></strong>,
                        amount: <strong className="text-danger">
                            <FormattedNumber
                                value={this.state.object.attributes.amount}
                                style={'currency'}
                                currency={this.state.object.attributes.currency}
                            />
                        </strong>,
                    }}
                />,
            ]
        } else if (this.state.object.attributes.status === 'declined') {
            return <FormattedMessage
                id="common.analytics.events.payment_declined.text"
                defaultMessage="A payment has been declined for an amount of {amount} while trying to pay {identifier}"
                values={{
                    identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                    amount: <strong>
                        <FormattedNumber
                            value={this.state.object.attributes.amount}
                            style={'currency'}
                            currency={this.state.object.attributes.currency}
                        />
                    </strong>,
                }}
            />
        }
        return ''
    }

    displayPaymentType() {
        const isDeclined = this.state.object.attributes.status === 'declined'
        return <div className={'mr-5 align-self-center'}>
            {
                this.state.creditMemo &&
                <div className={'w-100 mb-1'}>
                    <label className="col-form-label custom-form-label">
                        <a href="#" onClick={this.openCreditMemoEditionModal}> {this.state.creditMemo.attributes.identifier} </a>
                    </label>
                </div>
            }
            <h2 className={"m-0 d-flex justify-content-center"}>
                {
                    !this.state.creditMemo &&
                    <PaymentTypeIcon className={(isDeclined || this.state.isDeleted) ? 'text-danger' : ''}
                        value={this.state.object.attributes.payment.attributes.type}
                        icon={this.getPaymentTypeIcon()} />
                }
                {
                    this.state.creditMemo &&
                    <CreditMemoTypeIcon
                        value={this.state.creditMemo.attributes.type}
                        className={'mr-1 pb-0 ' + (this.state.isDeleted ? 'text-danger' : '')} />
                }
            </h2>
        </div>
    }

    displayPaymentLink() {
        const pay = this.state.object?.attributes.payment
        if (!pay) {
            return ""
        }

        return <EventInfoBlock
            label={<FormattedMessage
                id="common.payment_id.label"
                defaultMessage="Payment ID"
            />}
            info={<PaymentLink
                paymentId={pay.id}
                label={pay.attributes.identifier}
            />}
        />
    }


    displayPaymentAmount(payment) {
        payment = payment || this.state.object.attributes.payment
        let paymentAmount = payment.attributes.amount
        paymentAmount = !this.isReturn() ?
            paymentAmount : -paymentAmount

        return <div className={'mr-5'}>
            <div className={'w-100'}>
                <label className="col-form-label custom-form-label">
                    <strong>
                        <FormattedMessage
                            id="invoice.analytics.events.payment_received.payment_amount_spent"
                            defaultMessage="Payment amount"
                        />
                    </strong>
                </label>
            </div>
            <h4 className={"m-0 " + (this.state.isDeleted ? 'text-danger' : '')}>
                <FormattedNumber
                    value={paymentAmount}
                    style={'currency'}
                    currency={payment.attributes.currency}
                />
            </h4>
            {
                payment.attributes.status === 'pending' ?
                    <h6 className="text-warning border-bottom-0">
                        <FormattedMessage
                            id="payment.status.pending"
                            defaultMessage="Pending"
                        />
                    </h6> : ''
            }
        </div>
    }

    displayPaymentNote(payment) {
        payment = payment || this.state.object.attributes.payment
        const isDeclined = this.state.object.attributes.status === 'declined'

        return (this.state.object.attributes.creditMemo && this.state.object.attributes.creditMemo.attributes.notes) ||
            payment.attributes.note ?
            <div className={'mr-5'}>
                <div className={'w-100'}>
                    <label className="col-form-label custom-form-label">
                        <strong>
                            {isDeclined ? <FormattedMessage
                                id="common.analytics.events.payment_received.error_label"
                                defaultMessage="Error"
                            /> : <FormattedMessage
                                id="invoice.analytics.events.payment_received.note_label"
                                defaultMessage="Note"
                            />}
                        </strong>
                    </label>
                </div>
                <pre>
                    {
                        (this.state.object.attributes.creditMemo ?
                            this.state.object.attributes.creditMemo.attributes.notes : '')
                        || payment.attributes.note
                    }
                </pre>
            </div> : ''
    }

    displayPaymentSource(payment) {
        payment = payment || this.state.object.attributes.payment

        return payment.attributes.source ?
            <div className={'mr-5'}>
                <div className={'w-100'}>
                    <label className="col-form-label custom-form-label">
                        <strong>
                            <FormattedMessage
                                id="invoice.analytics.events.payment_received.source_label"
                                defaultMessage="Source"
                            />
                        </strong>
                    </label>
                </div>
                <p className={'mb-0'}>
                    <PaymentSource value={payment.attributes.source} />
                </p>
            </div> : ''
    }

    displayPaymentDate() {
        return this.state.object.attributes.capturedAt ?
            <div className={'mr-5'}>
                <div className={'w-100'}>
                    <label className="col-form-label custom-form-label">
                        <strong>
                            <FormattedMessage
                                id="invoice.analytics.events.payment_received.payment_date_label"
                                defaultMessage="Payment Date"
                            />
                        </strong>
                    </label>
                </div>
                <p className={'mb-0'}>
                    <FormattedDate
                        year='numeric'
                        month='long'
                        day='numeric'
                        hour='numeric'
                        minute='numeric'
                        value={new Date(this.state.object.attributes.capturedAt)} />
                </p>
            </div> : ''
    }

    displayOriginalCreditMemoPaymentMethod() {
        if (!this.state.creditMemo) {
            return <></>
        }

        const creditMemoOriginalPayment = this.state.creditMemo.attributes.payment
        if (!creditMemoOriginalPayment) {
            return <></>
        }
        if (creditMemoOriginalPayment.attributes.type === 'credit') {
            return <></>
        }

        return (
            <div className={'mr-5'}>
                <div className={'w-100'}>
                    <label className="col-form-label custom-form-label">
                        <strong>
                            <FormattedMessage
                                id="invoice.analytics.events.payment_received.original_credit_memo_payment_method_label"
                                defaultMessage="Original Payment Method"
                            />
                        </strong>
                    </label>
                </div>
                <p className={'mb-0'}>
                    <PaymentTypeIcon
                        className="mr-1"
                        value={creditMemoOriginalPayment.attributes.type}
                        icon={this.getPaymentTypeIcon(creditMemoOriginalPayment)}
                    />
                    <PaymentTypeLabel standalone={true} nameOnly={true} value={creditMemoOriginalPayment.attributes.type} />
                </p>
            </div>
        )
    }

    displayReturnPaymentRefundedAs() {
        return this.isReturn() &&
            parseFloat(this.state.object.attributes.amount) < 0 &&
            this.state.object.attributes.payment.attributes.type ?
            <div>
                <div className={'w-100'}>
                    <label className="col-form-label custom-form-label">
                        <strong>
                            <FormattedMessage
                                id="invoice.analytics.events.payment_received.refunded_as_label"
                                defaultMessage="Refunded as"
                            />
                        </strong>
                    </label>
                </div>
                <p className={'mb-0'}>
                    <PaymentTypeIcon className={'mr-1'} value={this.state.object.attributes.payment.attributes.type} icon={this.getPaymentTypeIcon()} />
                    <PaymentTypeLabel standalone={true} value={this.state.object.attributes.payment.attributes.type} />
                </p>
            </div> : ''
    }

    displayPaymentTransactionRefundedAt() {
        return this.state.object.attributes.refundedAt ?
            <div className={'mr-5'}>
                <div className={'w-100'}>
                    <label className="col-form-label custom-form-label">
                        <strong>
                            <FormattedMessage
                                id="invoice.analytics.events.payment_received.refunded_on_label"
                                defaultMessage="Refunded on"
                            />
                        </strong>
                    </label>
                </div>
                <p className={'mb-0'}>
                    <FormattedDate
                        year='numeric'
                        month='long'
                        day='numeric'
                        value={new Date(this.state.object.attributes.refundedAt)} />
                </p>
            </div> : ''
    }

    displayPaymentTransactionRefundedAs() {
        return this.state.object.attributes.refundedAs ?
            <div>
                <div className={'w-100'}>
                    <label className="col-form-label custom-form-label">
                        <strong>
                            <FormattedMessage
                                id="invoice.analytics.events.payment_received.refunded_as_label"
                                defaultMessage="Refunded as"
                            />
                        </strong>
                    </label>
                </div>
                <p className={'mb-0'}>
                    <PaymentTypeIcon className={'mr-1'} value={this.state.object.attributes.refundedAs} />
                    <PaymentTypeLabel standalone={true} value={this.state.object.attributes.refundedAs} />
                </p>
            </div> : ''
    }

    getDocumentID() {
        return this.props.invoice?.attributes.identifier
    }

    displayDeletePaymentTransactionOption() {
        const paymentTransaction = new PaymentTransaction(this.state.object)

        if (!paymentTransaction.canBeDetachedOrVoided()) {
            return <></>
        }

        return !this.state.isDeleted &&
            !['refunded', 'declined'].includes(this.state.object.attributes.status) &&
            !this.isReturn() && Guard.isAuthorized(Permissions.DeletePayment) ?
            <div className={'ml-auto align-self-end'}>
                <p className={'mb-1 mt-2'}>
                    <ConfirmButton
                        className={'btn btn-sm btn-outline-danger'}
                        onClick={this.deletePayment}
                        message={<DetachPaymentModalMessage
                            paymentTransaction={paymentTransaction}
                            documentID={this.getDocumentID()}
                        />}
                    >
                        {<DetachPaymentButtonMessage
                            paymentTransaction={paymentTransaction} />}
                    </ConfirmButton>
                </p >
            </div > : ''
    }

    displayPaymentInformation() {
        return <div className={'col-12 d-flex align-items-start flex-wrap'}>
            {
                this.displayPaymentType()
            }
            {
                this.displayPaymentLink()
            }
            {
                this.displayPaymentAmount()
            }
            {
                this.displayPaymentNote()
            }
            {
                this.displayPaymentSource()
            }
            {
                this.displayPaymentDate()
            }
            {
                this.displayOriginalCreditMemoPaymentMethod()
            }
            {
                this.displayReturnPaymentRefundedAs()
            }
            {
                this.displayPaymentTransactionRefundedAt()
            }
            {
                this.displayPaymentTransactionRefundedAs()
            }
            {
                this.displayDeletePaymentTransactionOption()
            }
        </div>
    }

    needsManualSync() {
        return this.state.object.attributes.status === PAYMENT_TRANSACTION_STATUS_SYNC_REQUESTED
    }

    renderRefundMessage() {
        if (!this.isReturn()) {
            return ""
        }

        switch (this.state.object.attributes.payment.attributes.status) {
            case PAYMENT_STATUS.CAPTURED:
                return <p className={'mb-1 d-flex align-items-center'}>
                    <FormattedMessage
                        id="invoice.analytics.events.return_refunded.text"
                        defaultMessage="Customer has been refunded for an amount of {amount}"
                        values={{
                            amount: <strong>
                                <FormattedNumber
                                    value={Math.abs(this.state.object.attributes.amount)}
                                    style={'currency'}
                                    currency={this.state.object.attributes.currency}
                                />
                            </strong>,
                        }}
                    />
                </p >
            case PAYMENT_STATUS.PENDING:
                return <>
                    <p className="mb-0">
                        <FormattedMessage
                            id="invoice.analytics.events.return_refund_pending.text"
                            defaultMessage="A refund of {amount} is currently processing."
                            values={{
                                amount: <strong>
                                    <FormattedNumber
                                        value={Math.abs(this.state.object.attributes.amount)}
                                        style={'currency'}
                                        currency={this.state.object.attributes.currency}
                                    />
                                </strong>,
                            }}
                        />
                    </p>
                    {this.state.object.attributes.payment?.attributes.externalLink?.attributes.integrationKey == INTEGRATION_KEY.RAINFOREST &&
                        <p className="text-warning">
                            <small>
                                <FormattedMessage
                                    id="invoice.analytics.events.return_refund_pending.info"
                                    defaultMessage="Refunds processed through QuoteMachine Payments may take up to 5 days to reflect on the customer's statement."
                                    values={{
                                        amount: <strong>
                                            <FormattedNumber
                                                value={Math.abs(this.state.object.attributes.amount)}
                                                style={'currency'}
                                                currency={this.state.object.attributes.currency}
                                            />
                                        </strong>,
                                    }}
                                />
                            </small>
                        </p>
                    }
                </>

        }
    }

    displayHeadMessage() {
        let paymentType = this.state.object.attributes.payment.attributes.type
        if (paymentType === 'external-checkout' && this.state.object.attributes.payment.attributes.integratedPayment) {
            paymentType = this.state.object.attributes.payment.attributes.integratedPayment.attributes.type
        }

        return [
            this.needsManualSync() && <div className="w-100 text-danger">
                <FormattedMessage
                    id="common.analytics.events.payment_sync_requested.text"
                    defaultMessage="This payment has been removed from your integration."
                />
            </div>,
            this.renderDeclinedMessage() ||
            (
                parseFloat(this.state.object.attributes.amount) > 0 ?
                    (!this.isReturn() ? !this.needsManualSync() && <FormattedMessage
                        id="invoice.analytics.events.payment_received.text"
                        defaultMessage="Invoice {identifier} received a {paymentType} of {amount}"
                        values={{
                            identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                            paymentType: <strong><PaymentTypeLabel value={paymentType} /></strong>,
                            amount: <strong>
                                <FormattedNumber
                                    value={this.state.object.attributes.amount}
                                    style={'currency'}
                                    currency={this.state.object.attributes.currency}
                                />
                            </strong>,
                        }}
                    /> : !this.needsManualSync() && <FormattedMessage
                        id="invoice.analytics.events.return_payment_received.text"
                        defaultMessage="Return {identifier} received a {paymentType} of {amount}"
                        values={{
                            identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                            paymentType: <strong><PaymentTypeLabel value={paymentType} /></strong>,
                            amount: <strong>
                                <FormattedNumber
                                    value={this.state.object.attributes.amount}
                                    style={'currency'}
                                    currency={this.state.object.attributes.currency}
                                />
                            </strong>,
                        }}
                    />)
                    : this.renderRefundMessage()

            ),
            this.state.object.attributes.status === 'refunded' ? <div className="badge badge-warning text-white ml-2">
                <FormattedMessage
                    id="invoice.analytics.events.payment_received.refunded_label"
                    defaultMessage="Refunded"
                />
            </div> : ''
        ]
    }

    getInvoiceExternalLink(integrationKey) {
        let externalLinks = this.state.invoice.attributes.externalLinks
        for (let i in externalLinks) {
            if (externalLinks[i].attributes.integrationKey === integrationKey) {
                return externalLinks[i]
            }
        }
    }

    isDepositRefund() {
        return this.state.invoice && this.state.invoice.attributes.refundFromCreditMemoId !== ''
    }

    hasNoTransactionExternalLink() {
        const transactionExternalLinks = this.state.object.attributes.externalLinks
            .filter(link => ![INTEGRATION_KEY.STRIPE, INTEGRATION_KEY.PAYSAFE, INTEGRATION_KEY.RAINFOREST].includes(link.attributes.integrationKey))
        return this.state.invoice.attributes.externalLinks.length > 0 && transactionExternalLinks.length === 0
    }

    displaySuperUserExportButton() {
        return (
            AppContext.getUserLoggedIn().attributes.superUser &&
                this.hasNoTransactionExternalLink() &&
                (!this.isReturn() || this.isDepositRefund()) ?
                <div className={'col-12 border-top pt-2 mt-2'}>
                    <div className={'w-100'}>
                        <p className={'mb-2'}>
                            <ActionButton className={"btn btn-sm btn-outline-primary"} onClick={this.exportIntegration}>
                                <Icon value={"cloud-upload-alt"} className={"mr-1"} />
                                <FormattedMessage
                                    id="payment_transaction.analytics.integration_export_btn"
                                    defaultMessage="Export"
                                />
                            </ActionButton>
                        </p>
                    </div>
                </div> : null
        )
    }

    getExternalLinksToDisplay() {
        return this.state.object.attributes.externalLinks.filter(link => !["stripe", "paysafe"].includes(link.attributes.integrationKey))
            .map(link => {
                //we save the transactionId as the externalId but we need to redirected using the invoice's external link
                if ([INTEGRATION_KEY.SHOPIFY, INTEGRATION_KEY.FRESHBOOKS].includes(link.attributes.integrationKey)) {
                    link = this.getInvoiceExternalLink(link.attributes.integrationKey)
                }
                return link
            })
    }

    displayExternalLinks() {
        const externalLinks = this.getExternalLinksToDisplay()
        return [
            externalLinks.map(link => {
                const url = Integrations.getPaymentTransactionExternalUrl(link)
                const integrationKey = link?.attributes?.integrationKey
                return <div className={integrationKey !== INTEGRATION_KEY.RAINFOREST ?
                    'col-12 border-top pt-2 mt-2' :
                    'col-12 pt-2 mt-2'}
                    key={link ? link.id : 'invoicePaymentTransaction'}
                >
                    <div className={'w-100'} >
                        <p className={'mb-2'}>
                            {Integrations.getPaymentExportedFormattedMessage(link)}
                        </p>
                    </div >
                    <div className={'w-100 d-flex align-items-start flex-wrap'}>
                        <div className={'mr-3'}>
                            <a href={url} target="_blank">
                                {Integrations.getPaymentExportedLogoImg(link)}
                            </a>
                        </div>
                        {integrationKey !== INTEGRATION_KEY.RAINFOREST &&
                            <div className={'align-self-center'}>
                                <p className={'mb-0'}>
                                    <a href={url} target={'_blank'} className={'btn btn-sm btn-outline-primary'}>
                                        {Integrations.getPaymentExportedCtaFormattedMessage(link)}
                                    </a>
                                </p>
                            </div>
                        }
                    </div>
                </div >
            }),
            this.state.object.attributes.payment.attributes.externalLink ?
                <div className={'col-12 border-top pt-2 mt-2'} >
                    <div className={'w-100'}>
                        <p className={'mb-2'}>
                            <FormattedMessage
                                id="invoice.analytics.events.payment_received_exported.integration"
                                defaultMessage="This payment was made with {integrationName}"
                                values={{
                                    integrationName: Integrations.getIntegrationNameFromKey(this.state.object.attributes.payment.attributes.externalLink.attributes.integrationKey)
                                }}
                            />
                        </p>
                    </div>
                    <PaymentExternalDetails value={this.state.object.attributes.payment} />
                </div> : '',
        ]
    }

    displayDeletedCreditMemoInformation() {
        return this.state.creditMemoFromDeletion &&
            <div className={'col-12 d-flex align-items-start flex-wrap border-top pt-2 mt-2'}>
                <div className={'w-100'}>
                    <Icon className={'mr-2 d-inline text-warning'} value={'info'} />
                    <p className={'mb-2 d-inline-block'}>
                        <FormattedMessage
                            id="invoice.analytics.events.payment_detached.converted_credit_memo.text"
                            defaultMessage="By detaching this payment, the credit memo {identifier} has been created"
                            values={{
                                identifier: <CreditMemoModalLink
                                    creditMemoId={this.state.creditMemoFromDeletion.id}
                                    creditMemoIdentifier={this.state.creditMemoFromDeletion.attributes.identifier}
                                    contactId={this.state.contactId} />,
                            }} />
                    </p>
                </div>
                <div className={'mr-5'}>
                    <div className={'w-100'}>
                        <label className="col-form-label custom-form-label">
                            <strong>{this.state.creditMemoFromDeletion.attributes.identifier}</strong>
                        </label>
                    </div>
                    <h2 className={"m-0"}>
                        <CreditMemoTypeIcon
                            value={this.state.creditMemoFromDeletion.attributes.type}
                            className={'mr-1'} />
                    </h2>
                </div>
                <div className={'mr-5'}>
                    <div className={'w-100'}>
                        <label className="col-form-label custom-form-label">
                            <strong>
                                <FormattedMessage
                                    id="invoice.analytics.events.payment_received.credit_memo_amount"
                                    defaultMessage="Credit memo amount"
                                />
                            </strong>
                        </label>
                    </div>
                    <h4 className={"m-0"}>
                        <FormattedNumber
                            value={this.state.creditMemoFromDeletion.attributes.amount}
                            style={'currency'}
                            currency={this.state.creditMemoFromDeletion.attributes.currency}
                        />
                    </h4>
                </div>
                {
                    parseFloat(this.state.creditMemoFromDeletion.attributes.remainingAmount) > 0 &&
                    <div className={'mr-5'}>
                        <div className={'w-100'}>
                            <label className="col-form-label custom-form-label">
                                <strong>
                                    <FormattedMessage
                                        id="invoice.analytics.events.payment_received.credit_memo_remaining_amount"
                                        defaultMessage="Remaining amount"
                                    />
                                </strong>
                            </label>
                        </div>
                        <h4 className={"m-0"}>
                            <FormattedNumber
                                value={this.state.creditMemoFromDeletion.attributes.remainingAmount}
                                style={'currency'}
                                currency={this.state.creditMemoFromDeletion.attributes.currency}
                            />
                        </h4>
                    </div>
                }
                {
                    this.state.creditMemoFromDeletion.attributes.notes ?
                        <div className={'mr-5'}>
                            <div className={'w-100'}>
                                <label className="col-form-label custom-form-label">
                                    <strong>
                                        <FormattedMessage
                                            id="invoice.analytics.events.payment_received.credit_memo_note_label"
                                            defaultMessage="Note"
                                        />
                                    </strong>
                                </label>
                            </div>
                            <pre>
                                {this.state.creditMemoFromDeletion.attributes.notes}
                            </pre>
                        </div> : ''
                }
            </div>
    }

    isPendingOrExpiredExternalShopifyCheckout() {
        if (!this.state.object) {
            return false
        }

        const payment = this.state.object.attributes.payment
        if (!payment) {
            return false
        }

        const integratedPayment = payment.attributes.integratedPayment
        if (!integratedPayment) {
            return false
        }

        return [PAYMENT_STATUS.PENDING, PAYMENT_STATUS.EXPIRED].includes(integratedPayment.attributes.status) &&
            integratedPayment.attributes.paymentFlowType === 'external-checkout' &&
            integratedPayment.attributes.integrationKey.includes('shopify')
    }

    render() {

        if (this.isPendingOrExpiredExternalShopifyCheckout()) {
            return <ShopifyExternalCheckoutPaymentAttemptEvent
                paymentTransaction={this.state.object}
                payableEntity={this.state.invoice}
                paymentInformation={this.displayPaymentInformation()}
            />
        }

        return <div className={"row " + this.state.className}>
            {this.state.modal}

            <div className="col-12">
                {
                    this.displayHeadMessage()
                }
            </div>
            {
                this.displayPaymentInformation()
            }

            {
                this.displaySuperUserExportButton()
            }

            {
                this.displayExternalLinks()
            }

            {
                this.displayDeletedCreditMemoInformation()
            }

        </div>
    }

}

export default injectIntl(InvoicePaymentReceivedEvent)





// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-payment-received.component.jsx